package com.eladfinish.bible.contest.features.verseWidget

import kotlinx.serialization.Serializable

/**
 * A verse as the widget shows it.
 *
 * @property text the verse in gershaim and with its sof pasuk, without teamim unless the config asks for them,
 * and without nikud when the config says so.
 * @property reference e.g. "משלי ג׳, ה׳".
 * @property bookNumber 1-based number of the book in the Tanakh.
 * @property chapter 1-based.
 * @property verse 1-based.
 */
@Serializable
data class WidgetVerse(
    val text: String,
    val reference: String,
    val bookNumber: Int,
    val chapter: Int,
    val verse: Int,
)

/** The verse shown from [startEpochSeconds] until the next entry starts. */
@Serializable
data class WidgetScheduleEntry(
    val startEpochSeconds: Long,
    val verse: WidgetVerse,
)
